<mat-form-field [color]="color" [appearance]="appearance" [floatLabel]="floatLabel">
    @if (floatLabel === 'always') {
      <mat-label>File Type</mat-label>
    }
    <mat-select
      [multiple]="multiple"
      [formControl]="control"
      [required]="required"
      [placeholder]="placeholder"
      [disabled]="disabled"
      (closed)="onChange()">
      @if (multiple) {
        <mat-select-trigger>
            @if ((control.value?.length || 0) === 1) {
            <span>
                {{getLabel(control.value[0]) || ''}}
            </span>
            }
            @if ((control.value?.length || 0) > 1 && (control.value?.length) == selectOptions.length) {
            <span>
                All
            </span>
            }
            @if ((control.value?.length || 0) > 1 && (control.value?.length) < selectOptions.length) {
            <span>
                Multiple
            </span>
            }
            @if ((control.value?.length || 0) > 1) {
            <span>
                ({{getSelectCount()}})
            </span>
            }
        </mat-select-trigger>
      }
  
      <mat-option>
        <ngx-mat-select-search
          placeholderLabel="search..."
          noEntriesFoundLabel="No Payers Found"
          [id]="'filter-' + controlName"
          [formControl]="filterControl"
          [showToggleAllCheckbox]="multiple"
          [toggleAllCheckboxChecked]="allToggled"
          [toggleAllCheckboxIndeterminate]="indeterminateToggle"
        (toggleAll)="allOptionClicked($event)"></ngx-mat-select-search>
      </mat-option>
  
      @for (option of filteredOptions | async; track option) {
        <mat-option
          #item
          [value]="option.value"
          (click)="toggleSelection(item, option)">
          {{option.label}}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
  